<billing-ui-simple-price-display
  [currencyCode]="currencyCode"
  [componentTextLength]="form"
  [view]="view"
  [price]="price"
  [prices]="prices"
  [frequency]="frequency"
  [setupFee]="setupFee"
  [commitment]="commitment"
  [fees]="fees"
  [discounts]="discounts"
  [stairSteps]="stairSteps"
  [align]="align"
  [contactSales]="contactSales"
  [topLabel]="topLabel"
  [priceUnavailable]="shouldShowPriceUnavailable"
></billing-ui-simple-price-display>
